
<template>
  <div>
    <v-container>
      <div class="text-center background text border pt-2 pb-2">
        <div class="text-center mr-5 ml-5 mt-4">
          <h4>Select option</h4>
          <!-- <small>Select search option</small> -->
          <hr />
        </div>
        <v-row>
          <v-col class="col-4 text-center">
            <div
              v-if="option == 'world'"
              class="hoverable p-3 ml-5 mb-3 bg-secondary"
            >
              World
            </div>
            <div
              v-else
              @click="optionSelect('world')"
              class="hoverable p-3 ml-5 mb-3"
            >
              World
            </div>
          </v-col>
          <v-col class="col-4 text-center">
            <div
              v-if="option == 'item'"
              class="hoverable p-3 mb-3 bg-secondary"
            >
              Item
            </div>
            <div
              v-else
              @click="optionSelect('item')"
              class="hoverable p-3 mb-3"
            >
              Item
            </div>
          </v-col>
          <v-col class="col-4 text-center">
            <div
              v-if="option == 'transfer'"
              class="hoverable p-3 mr-5 mb-3 bg-secondary"
            >
              Transfer
            </div>
            <div
              v-else
              @click="optionSelect('transfer')"
              class="hoverable p-3 mr-5 mb-3"
            >
              Transfer
            </div>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>



<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      optionSelected: "bg-secondary",
      option: "world",
    };
  },
  methods: {
    ...mapMutations(["setSearchOption", "setWorldUndefined"]),
    optionSelect(option) {
      this.option = option;
      this.setSearchOption(option);
      this.setWorldUndefined();
    },
  },
};
</script>


<style scoped>
.background {
  background-color: rgb(12, 25, 32);
}

.text {
  color: rgb(238, 195, 147);
}

.border {
  border-radius: 10px;
  border-width: 2px;
  border-color: white;
}

.hoverable {
  border-radius: 10px;
}

.hoverable:hover {
  cursor: pointer;
  border-radius: 10px;
  background-color: rgb(60, 60, 60);
}
</style>